import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";
import { Add, Edit, Delete, Close } from "@mui/icons-material";
import "./SalaryPayout.css";

const emptyForm = {
  id: "",
  employeeName: "",
  paymentMode: "",
  bankName: "",
  city: "",
  branchName: "",
  ifscCode: "",
  foodCoupons: "",
};

const SalaryPayoutFile = () => {
  const [data, setData] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [open, setOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const openModal = (row = null, index = null) => {
    setForm(row || emptyForm);
    setEditIndex(index);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setForm(emptyForm);
    setEditIndex(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (Object.values(form).some((v) => v === "")) {
      alert("All fields are required");
      return;
    }

    if (editIndex !== null) {
      const updated = [...data];
      updated[editIndex] = form;
      setData(updated);
    } else {
      setData([...data, form]);
    }
    closeModal();
  };

  const handleDelete = (index) => {
    if (window.confirm("Delete this record?")) {
      setData(data.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="payout-wrapper">
      <div className="payout-card">
        <div className="payout-header">
          <h2>Salary Payout File</h2>
          <Button
            className="payout-add-btn"
            startIcon={<Add />}
            onClick={() => openModal()}
          >
            Add Record
          </Button>
        </div>

        <TableContainer component={Paper} className="payout-table">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Employee Name</TableCell>
                <TableCell>Payment Mode</TableCell>
                <TableCell>Bank Name</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>IFSC Code</TableCell>
                <TableCell>Food Coupons</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.employeeName}</TableCell>
                  <TableCell>{row.paymentMode}</TableCell>
                  <TableCell>{row.bankName}</TableCell>
                  <TableCell>{row.city}</TableCell>
                  <TableCell>{row.branchName}</TableCell>
                  <TableCell>{row.ifscCode}</TableCell>
                  <TableCell>{row.foodCoupons}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="warning"
                      onClick={() => openModal(row, index)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(index)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {!data.length && (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No payout records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* MODAL */}
      <Modal open={open} onClose={closeModal}>
        <Box className="payout-modal">
          <div className="modal-header">
            <h3>Salary Payout Entry</h3>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </div>

          <div className="modal-grid">
            <TextField label="Employee ID" name="id" value={form.id} onChange={handleChange} size="small" />
            <TextField label="Employee Name" name="employeeName" value={form.employeeName} onChange={handleChange} size="small" />
            <TextField label="Payment Mode" name="paymentMode" value={form.paymentMode} onChange={handleChange} size="small" />
            <TextField label="Bank Name" name="bankName" value={form.bankName} onChange={handleChange} size="small" />
            <TextField label="City" name="city" value={form.city} onChange={handleChange} size="small" />
            <TextField label="Branch Name" name="branchName" value={form.branchName} onChange={handleChange} size="small" />
            <TextField label="IFSC Code" name="ifscCode" value={form.ifscCode} onChange={handleChange} size="small" />
            <TextField label="Food Coupons" name="foodCoupons" value={form.foodCoupons} onChange={handleChange} size="small" />
          </div>

          <Button className="payout-save-btn" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default SalaryPayoutFile;
